import React from 'react';
import { SpacingStack } from '@components/SpacingStack';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { Text } from '@components/typography';
import { Circle, Flex } from './BrandAssetSection.styles';
import { ReactComponent as Photo } from './svgs/photo.svg';
import { ReactComponent as Brand } from './svgs/brand.svg';
import { ReactComponent as Officiant } from './svgs/officiant.svg';
import { newsroomPageData } from '@data-ts/pages/newsroom';
import { Button } from '@components/Button';

const { logosTitle, photosTitle, pressKitTitle, downloadButtonText } = newsroomPageData.brandAssets;
const brandContent = [
  {
    id: 'logosButton',
    svg: <Brand />,
    title: logosTitle,
    url: 'https://www.dropbox.com/sh/8ifjjd22xcfq0ho/AAA1R6Xhggb4gjZS3hCuotfLa?dl=0',
  },
  {
    id: 'photosButton',
    svg: <Photo />,
    title: photosTitle,
    url: 'https://www.dropbox.com/sh/enxgx88lhhnjebw/AABPoOl4aaM_YvxAbS7LNPyza?dl=0',
  },
  {
    id: 'pressKitButton',
    svg: <Officiant />,
    title: pressKitTitle,
    url: 'https://www.dropbox.com/sh/qmzsg80bohpzyie/AACIgI78GQT-WfX3pYeN4yOoa?dl=0',
  },
];

export const BrandAssetSection = () => {
  return (
    <Box paddingY={[0, 10, 12]} backgroundColor="mono7" id="brand-assets">
      <SpacingStack spacing={[10, 10, 12]}>
        <Text tagName="h2" color="purple6" variant="hed72Hero" style={{ textAlign: 'center' }}>
          Brand Assets
        </Text>
        <Columns>
          {brandContent.map((content, index) => (
            <Columns.Column key={index} width="one-third">
              <Box paddingY={[10, 0, 0]}>
                <Flex flexDirection="column">
                  <Text variant="dek24" tagName="span" color="purple6">
                    {content.title}
                  </Text>
                  <Circle>{content.svg}</Circle>
                  <Button id={content.id} variant="secondary" forwardedAs={'a'} href={content.url}>
                    {downloadButtonText}
                  </Button>
                </Flex>
              </Box>
            </Columns.Column>
          ))}
        </Columns>
      </SpacingStack>
    </Box>
  );
};
